import { render } from "./CouponModal.vue?vue&type=template&id=318919ba"
import script from "./CouponModal.vue?vue&type=script&lang=js"
export * from "./CouponModal.vue?vue&type=script&lang=js"

import "./CouponModal.vue?vue&type=style&index=0&id=318919ba&lang=scss"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__